
export const PRODUCTS_ICONS_MAP = {
  "HSA": "fa-light fa-sack-dollar",
  "DC-FSA": "fa-light fa-family",
  "HC-FSA": "fa-light fa-prescription-bottle-medical",
  "HRA": "fa-light fa-clipboard-medical",
  "MassTransit": "fa-light fa-bus",
  "COBRA": "fa-light fa-display-medical",
  "WellnessIncentiveAccounts": "fa-light fa-person-meditating",
  "DirectBill": "fa-light fa-file-invoice-dollar",
  "HealthPlanDecisionSupport": "fa-light fa-laptop-medical",
  "RRA": "fa-light fa-users-medical",
  "LP-FSA": "fa-light fa-tooth",
  "LSA": "fa-light fa-dumbbell",
  "Parking": "fa-light fa-car-building",
} as const;
